import { krdetailConstants } from '../constants/krdetails.constants';

type TranslateFn = (key: string) => string;

type ProgressTypeMetric = {
  source?: number | string;
  mirrorSource?: number | string;
  counting?: number | string;
  progress_type?: number | string | null;
  child_progress_type?: number | string | null;
};

function supportsProgressCalculationContext(metric: ProgressTypeMetric): boolean {
  const source = Number(metric.mirrorSource || metric.source);
  const counting = Number(metric.counting);
  if (counting === krdetailConstants.METRIC_COUNTING_RANGE) {
    return false;
  }
  const unsupportedSources = [
    krdetailConstants.SOURCE_WORKSTREAM,
    krdetailConstants.SOURCE_AVG_CYCLE_TIME,
  ];
  return !unsupportedSources.includes(source);
}

export function supportsProgressTypeDisplay(metric: ProgressTypeMetric): boolean {
  if (metric.progress_type == null || metric.progress_type === '') {
    return false;
  }
  return supportsProgressCalculationContext(metric);
}

export function supportsChildProgressTypeDisplay(metric: ProgressTypeMetric): boolean {
  if (metric.child_progress_type == null || metric.child_progress_type === '') {
    return false;
  }
  return supportsProgressCalculationContext(metric);
}

export function getProgressTypeText(
  progressType: number | string,
  source: number | string,
  counting: number | string,
  t: TranslateFn,
  inline = false,
): string {
  const survey = (source == krdetailConstants.SOURCE_SURVEY);
  if (progressType == krdetailConstants.PROGRESS_TYPE_LAST_UPDATE) {
    if (survey && counting == 0) {
      return t('averaged each time data is collected');
    }
    return t(inline ? 'last entered value' : 'Last entered value');
  }
  if (progressType == krdetailConstants.PROGRESS_TYPE_TOTAL) {
    if (survey && counting == 0) {
      return t('sum all the data collected over time');
    }
    return t(inline ? 'total of entered values' : 'Total of entered values');
  }
  if (progressType == krdetailConstants.PROGRESS_TYPE_AVERAGE) {
    if (survey && counting == 0) {
      return t('sum the responses each time data is collected and average the results over time');
    }
    return t(inline ? 'average of entered values' : 'Average of entered values');
  }
  return t(inline ? 'sum of last value' : 'Sum of last value');
}
